import _ from 'lodash'
import { findMax } from './common_product_list_pro'
import {
  typeBool,
  _setNull,
  _getValue,
  createNumberList,
  combine,
} from '../common/basefn'
import {
  setMinArr,
  staticSKU,
  diffcreator, // 是否是创建者
  diffSKUCondition, // 判断SKU页签显示的条件之一
  diffstopstatus, // 启用状态 启用：业务信息 - 上下架 可以选择 ；停用 ：业务信息 - 上下架 禁用
  diffiStatus, // 商城上架
  diffiUOrderStatus, // U订货上架
  diffbasicInfo, // 基本信息判断（是否是创建者）
  diffrealProductAttribute, // 商品性质
  diffvirtualProductAttribute, // 虚拟单位
  diffrealProductAttributeType, // 实物商品属性
  diffbusinessAttribute, // 业务属性
  diffsaleChannel, // 销售渠道改变
  diffbusinesSattriBute, // 业务属性
  diffsaleStyle, // 销售方式
  measurementUnitArr, // 计量单位
  diffproductTemplate, // 更改商品模板
  clearTemplate, // 清空模板带来的数据
  diffmeasurementUnitArr, // 比较计量单位
  updatemeasurementUnitArr, // 更新计量单位
  clearmeasurementUnitArr, // 清空计量单位
  // clearbatchPriceUnit, // 清空批发报价单位
  // diffbatchPriceUnit, // 批发报价单位
  diffUnit, // 辅计量单位 与 主计量单位 比
  getbaseInfoToSKU, // 获取商品基本信息转换成SKU列表里面的基本信息
  getPriceToSKU, // 获取商品价格转换成SKU列表里面的价格
  diffisDisplayPrice, // 价格提示信息 显示隐藏
  diffisBatchManage, // 批次管理
  diffisExpiryDateManage, // 有效期管理
  diffisSerialNoManage, // 序列号管理
  diffdepositDealPayType, // 定金设置方式
  difftimes_ControlTimeType, // 线上付尾款控制方式
  diffenableDeposit, // 启动预订业务
  difftimes_iControlTime, // 线上付尾款规则
  diffdepositPayType, // 支付尾款方式
  diffisProcess, // 加工
  diffprocessType, // 加工方式
  diffcanOrder, // 可预约
  // diffcheckByBatch, // 按批次核算
  diffSKUShelve, // sku 商城/U订货批量上下架
  diffFreex,
  diffSKUPropertySums, // 隐藏SKU扩展属性
  diffisCheckFree, // 按规格核算
  diffPropertySums, // 隐藏商品扩展属性
  diffOrderPropertySums, // 商品订单属性
  diffskulvprice, // 会员价
  diffproductSKUDetail, // SKU列表上架（商城/U订货）
  diffSource, // 检测来源
  diffcalTotalInventory, // 线上库存量是否可以编辑
  applicationScope, // 适用范围
  diffOrgsScope, // 适用范围 - 不能试用同一范围
  diffShopScope, // 适用范围 - 不能试用同一商家
  rolesUnits, // 较量计量单位
  hasUnits, // 模板中计量单位 是否有值
  geturl,
  diffmergeCell,
  insertState, // 添加status
  diffproductskusCode, // productskus sku编码 重复验证
} from './PC_pc_product_VM_pro'
const loadfn = (viewmodel) => { // viewmodel 加载之后要运行的函数
  let offlineUnit_NameModel = viewmodel.get('detail!offlineUnit_Name');
  let batchPriceUnit_NameModel = viewmodel.get('detail!batchPriceUnit_Name');
  let _mainval = _getValue(viewmodel, 'unit_Name');
  let _keyval = _getValue(viewmodel, 'unit');
  let mode = viewmodel.getParams().mode;
  offlineUnit_NameModel.setDisabled(true);
  batchPriceUnit_NameModel.setDisabled(true);

  /** 前端不强制修改显示辅计量
  if (mode != 'browse') {
    offlineUnit_NameModel.setValue(_mainval);
    batchPriceUnit_NameModel.setValue(_mainval);
  }
  viewmodel.get('detail!offlineUnit').setValue(_keyval);
  viewmodel.get('detail!batchPriceUnit').setValue(_keyval);
   */

  viewmodel.execute('updateViewMeta', {
    code: 'DefaultSKUOrderPropsGroup',
    visible: false,
  }); // 页面 商品订单属性 组
  viewmodel.execute('updateViewMeta', { code: '商品属性页签', visible: false });
  viewmodel.execute('updateViewMeta', { code: 'SKU页签', visible: false });
  viewmodel.get('beUpTime').setState("format", "YYYY-MM-DD HH:mm:ss"); // 设置上架时间
  viewmodel.get('productAssistClasses').setState('checkStrictly', false); // 商品辅助分类
  viewmodel.get('customerServiceDay').setState('min', 1); // 售后服务期限 大于1
  viewmodel.get('detail!expireDateNo').setState('min', 1); // 保质期
  // viewmodel.get('btnSKUBatchEdit').setState('popoverKey', 'BatchSKU'); // 批量改行
  setTimeout(function () {
    viewmodel.get('productskus') && viewmodel.get('productskus').setState('mergeCells', true); // 设置productskus 合并单元格
  }, 10)
  viewmodel.get('productskus') && viewmodel.get('productskus').setState('mergePosition', 'first'); // 设置productskus 合并模式
  diffmergeCell(viewmodel, viewmodel)
  let rateArr = ['detail!inTaxrate', 'detail!outTaxrate']; // 进项税率%  销项税率%
  rateArr.forEach((val) => {
    let valModel = viewmodel.get(val);
    valModel.setState("min", 0);
    valModel.setState("max", 99);
  });
  setMinArr.forEach((val) => {
    viewmodel.get(val).setState("min", 0);
  });
  // 成交金额百分比
  viewmodel.get("detail!depositPercentage").setState("max", 99);
  let stopstatusData = _getValue(viewmodel, 'detail!stopstatus'); // 启用状态
  let val = typeBool(stopstatusData, false); // false 启用 true 停用
  if (val) {
    viewmodel.get('detail!iUOrderStatus').setDisabled(true);
    viewmodel.get('detail!iStatus').setDisabled(true);
  }
  // 会员价有值 会员价显示 会员价没值则不显示
  let productLvPriceslist = viewmodel.get('productLvPrices').getAllData();
  viewmodel.execute('updateViewMeta', {
    code: 'LvPriceGroup',
    visible: !!productLvPriceslist.length,
  });
  diffbusinessAttribute(viewmodel); // 业务属性
  diffmeasurementUnitArr(viewmodel); // 计量单位
  diffisDisplayPrice(viewmodel); // 线上不显示价格时，需要显示的提示信息 默认不显示
  diffisBatchManage(viewmodel); // 批次管理
  diffenableDeposit(viewmodel); // 预订业务
  diffisSerialNoManage(viewmodel); // 序列号管理
  diffisProcess(viewmodel); // 加工
  diffcanOrder(viewmodel); // 可预约
  diffsaleStyle(viewmodel); // 销售方式
  createNumberList(30).forEach((val, i) => { // 商品属性初始非必输
    viewmodel.get('define!define' + (i + 1)).setState('bIsNull', true);
  })
  applicationScope(viewmodel, 'productShops'); // 适用范围 组织 商家
  applicationScope(viewmodel, 'productOrgs');
  viewmodel.get('productCheckFrees').setState('visible', false); // 按核算规格名称
  viewmodel.get('detail!isCheckFree').setState('visible', false); // 按核算规格名称
  viewmodel.get('time!dateRange').setValue([
    _getValue(viewmodel, 'time!dStartDate'),
    _getValue(viewmodel, 'time!dEndDate'),
  ]);
  viewmodel.get('detail!processType').setState('afterPopoverKey', 'ProcessTypePopover'); // 加工方式
}
cb.define(['common/common_VM.Extend.js'], function (common) { // 商品档案
  var PC_pc_product_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let carryParams = viewmodel.getParams().carryParams;
      if (carryParams && carryParams.mode == 'browse') {
        viewmodel.getParams().mode = 'browse'
      }
      let SpecSums = []; // 商品规格
      let saleChannel = []; // 销售渠道的值
      let specNamesObj = {}; // 商品规格名称 映射 {866937324097792: "free101", 857035213197568: "free100"}
      let specIdsObj = {}; // 规格值 ID 与值的的映射
      let SpecificationsShowItems = []; // SKU 列表里删除的SKU
      let OrderPropertySums = []; // 订单属性
      let enableCyclePurchase = false; // 是否启用周期购
      let virtualProductAttributeData = 7; // 虚拟商品属性
      let skusobj = {}; // 自定义规格对照 freex   {free101: "freex1"}
      let skuobjIdName = []; // SKU自定义规格名称
      let specItemObj = {}; // 规格项 ID -> Name 对比  {"free100":"规格名"}
      let checkFreesData = [] // 自定义规格值
      let productskusModel = viewmodel.get('productskus');
      let firstInitSKU = 0;
      let templateLoadNumber = 0; // 是否加载过模板
      let showItems2 = []; // 自定义规格
      // let defaultcode = _getValue(viewmodel, 'code');
      // 浏览态下翻页
      const refreshData = (viewmodel, num) => {
        let parentModel = viewmodel.getCache('parentViewModel').getGridModel();
        let index = parentModel.getFocusedRowIndex() + num;
        let length = parentModel.getAllData().length;
        if (index < 0) {
          cb.utils.alert("没有上一条了", 'warning');
          return false
        } else if (index === length) {
          cb.utils.alert("没有下一条了", 'warning');
          return false
        }
        parentModel.setFocusedRowIndex(index);
        let rowData = parentModel.getRow(index);
        let proxy = cb.rest.DynamicProxy.create({
          detail: { url: '/bill/detail', method: 'GET' },
        });
        carryParams["productApplyRangeId"] = rowData.productApplyRangeId;
        carryParams["isCreator"] = rowData.isCreator;
        carryParams["isApplied"] = rowData.isApplied;
        let params = {
          billnum: "pc_product",
          terminalType: 1,
          id: rowData.productId || rowData.id,
          productApplyRangeId: rowData.productApplyRangeId,
          isCreator: rowData.isCreator,
          isApplied: rowData.isApplied,
          mode: 'browse',
        };
        proxy.detail(params, (err, args) => {
          viewmodel.loadData(args)
        })
      }
      viewmodel.on('beforeMoveprev', (args) => {
        refreshData(viewmodel, -1);
        return false
      });
      viewmodel.on('beforeMovenext', (args) => {
        refreshData(viewmodel, 1);
        return false
      });
      // sku列表添加checkbox
      productskusModel.setShowCheckbox(true);
      productskusModel.on('afterMount', () => {
        let columns= productskusModel._get_data('columns');
        let fieldNames = [];
        Object.keys(columns).map(key => {
          let col = columns[key];
          if(col.bShowIt && !col.bHidden) {
            fieldNames.push(col.cItemName);
          }
        })
        productskusModel.setColumns(columns,fieldNames);
      })

      /* ------------------------------------------------- 基本信息 ------------------------------------------------- */
      const diffSKU = (viewmodel) => {
        _setNull(viewmodel, 'couponId_Name');
        let _val = !!SpecSums.length && diffSKUCondition(viewmodel)
        viewmodel.execute('updateViewMeta', { code: 'SKU页签', visible: _val });
        viewmodel.get('productCheckFrees').setState('visible', _val)
        viewmodel.get('detail!isCheckFree').setState('visible', _val)
        if (!_val) { // 隐藏页签 并清空 数据
          viewmodel.execute('updateViewMeta', {
            code: '商品属性页签',
            visible: false,
          });
          viewmodel.execute('updateViewMeta', {
            code: 'SKU页签',
            visible: false,
          });
          viewmodel.execute('updateViewMeta', {
            code: 'DefaultSKUOrderPropsGroup',
            visible: (!SpecSums.length && !!OrderPropertySums.length),
          });
          createNumberList(30).forEach((val, i) => {
            let _defineId = 'define!define' + (i + 1);
            viewmodel.get(_defineId).setState('bIsNull', true);
          })
          const userType = cb.rest.AppContext.user ? cb.rest.AppContext.user.userType : null;
          // if (userType === 5 || userType === 4) {
          //   productskusModel.setColumnState("productSKUDetail!fSettleAccountsRate", 'bIsNull', false)
          // }
          let productskusData = productskusModel.getData() || [];
          if (productskusData.length) {
            productskusModel.deleteRows(createNumberList(productskusData.length));
          }
          let productspecitemsModel = viewmodel.get('productspecitems');
          let productspecitemsData = productspecitemsModel.getData() || [];
          if (productspecitemsData.length) {
            productspecitemsModel.deleteItems(createNumberList(productspecitemsData.length));
          }
          let productparamsModel = viewmodel.get('productParams');
          let productparamsData = productparamsModel.getData() || [];
          if (productparamsData.length) {
            productparamsModel.deleteRows(createNumberList(productparamsData.length));
          }
        }
      }
      // 商品性质 改变
      viewmodel.get('realProductAttribute').on('afterValueChange', (args) => {
        if (args.value.value == 1) {
          viewmodel.get('realProductAttributeType').setValue(1);
        }
        diffrealProductAttribute(viewmodel, virtualProductAttributeData, saleChannel);
        diffbusinessAttribute(viewmodel);
        diffSKU(viewmodel)
      });
      // 实物商品属性
      viewmodel.get('realProductAttributeType').on('afterValueChange', (args) => {
        if (args.async === false) return
        diffrealProductAttributeType(viewmodel);
        diffbusinessAttribute(viewmodel);
        diffSKU(viewmodel)
      })
      // 当虚商品属性 改变
      viewmodel.get('virtualProductAttribute').on('afterValueChange', () => {
        diffvirtualProductAttribute(viewmodel);
        diffSKU(viewmodel)
      })
      // // 当业务属性 改变 物料的业务属性选择“销售”时，商品分类必输
      // viewmodel.get('detail!businessAttribute').on('afterValueChange', () => {
      //   diffbusinesSattriBute(viewmodel);
      // })
      let couponId_NameModel = viewmodel.get('couponId_Name')
      // 卡券 弹窗打开之前
      couponId_NameModel.on('beforeBrowse', function (data) {
        let realProductAttribute = _getValue(viewmodel, 'realProductAttribute');
        let userType = cb.rest.AppContext.user.userType;
        let condition = { "isExtend": true, simpleVOs: [] };
        if (userType == 0 || userType == 1) { // 租户管理员、租户操作员取平台卡券
          let platformCondition = { field: 'scopeLevel', op: 'eq', value1: 0 };
          condition.simpleVOs.push(platformCondition);
        } else if (userType == 4 || userType == 5) { // 商家管理员、商家操作员取无限制卡券（适用全部、适用商家不限制）和商家卡券
          let shopCondition = {
            logicOp: 'or',
            conditions: [
              {
                field: 'couponShops.shopId',
                op: 'eq',
                value1: cb.rest.AppContext.user.shop,
              },
              { field: 'shopOrOrg', op: 'eq', value1: 0 },
            ],
          };
          let shopSubCondition = {
            logicOp: 'and',
            condition: [
              { field: 'shopOrOrg', op: 'eq', value1: 1 },
              { field: 'unLimitShop', op: 'eq', value1: 1 },
              { field: 'deleted', op: 'eq', value1: 0 },
            ],
          };
          shopCondition.conditions.push(shopSubCondition);
          condition.simpleVOs.push(shopCondition);
        } else {
          let nullCondition = { field: 'id', op: 'eq', value1: -1 }
          condition.simpleVOs.push(nullCondition);
        }
        let realProductCondition = {
          field: 'isElec',
          op: 'eq',
          value1: realProductAttribute == 1 ? 0 : 1,
        };
        condition.simpleVOs.push(realProductCondition);
        // 虚拟卡券需要过滤掉微信卡券
        if (realProductAttribute == 2) {
          let wechatCondition = {
            field: 'syncWeChatCoupon',
            op: 'eq',
            value1: 0,
          };
          condition.simpleVOs.push(wechatCondition);
        }
        couponId_NameModel.setFilter(condition);
      });
      // 填写完名称后，自name动填充助记码
      viewmodel.get("name").on('afterValueChange', (args) => {
        let name = _getValue(viewmodel, 'name');
        let oldname = args.oldValue;
        // 如果有商品名称旧值 并且拿旧值取到的助记码和现有的助记码对比
        // 不一致，则不生成新的助记码，如果一致则覆盖原有助记码
        let oldMnemonicCode = oldname ? common.getMnemonicCode(oldname) : [] // 得到数组
        let mnemonicCode = _getValue(viewmodel, "mnemonicCode");
        if (oldMnemonicCode[0] === mnemonicCode) {
          if (name) {
            let getMnemonicCode = common.getMnemonicCode(name); // 得到数组
            viewmodel.get("mnemonicCode").setValue(getMnemonicCode[0]);
          } else {
            viewmodel.get("mnemonicCode").setValue("");
          }
        }
        // 商品名称改变 检测商品商品简称的值
        let shortNameModel = viewmodel.get('shortName');
        let shortName = shortNameModel.getValue();
        if (!shortName) {
          shortNameModel.setValue(args.value);
        }
        let productskusList = productskusModel.getAllData();
        productskusList.length && productskusList.forEach((val, index) => {
          if (name && !val["productSKUDetail!shortName"]) {
            productskusModel.setCellValue(index, 'productSKUDetail!shortName', name)
          }
        })
      });
      // 卡券 值改变后
      couponId_NameModel.on('afterValueChange', ({ value }) => {
        const _name = value ? value.name.substr(4) : null;
        let nameModel = viewmodel.get('name');
        nameModel.setValue(_name);
        nameModel.execute('afterValueChange', { value: _name });
      })
      // 启用状态改变
      viewmodel.get('detail!stopstatus').on('afterValueChange', (args) => {
        if (args.async !== false) {
          diffstopstatus(viewmodel);
          if (args.value.value === 'true') {
            let proxy = cb.rest.DynamicProxy.create({
              _label: {
                url: '/api/upc/getOption/appliedControlledByCreator',
                method: 'GET',
              },
            });
            proxy._label({}, (err, params) => {
              if (err) {
                cb.utils.alert(err.message, 'error');
                return false;
              }
              let appliedControlledByCreator = params.appliedControlledByCreator;
              if (appliedControlledByCreator == "1") {
                cb.utils.alert('商品停用时，商品（包括分配给下级经销商或组织的商品）都会自动下架', 'warning');
              }
            })
          }
        }
      })
      // 商城上架
      viewmodel.get('detail!iStatus').on('afterValueChange', () => {
        diffiStatus(viewmodel)
      })
      // U订货上架
      viewmodel.get('detail!iUOrderStatus').on('afterValueChange', () => {
        diffiUOrderStatus(viewmodel)
      })
      // 销售渠道的值改变
      viewmodel.get('detail!saleChannel').on('afterValueChange', (args) => {
        diffsaleChannel(viewmodel, args);
      });
      // 当选中虚拟商品时，线上批发不可选择
      viewmodel.get('detail!saleChannel').on('beforeValueChange', ({ value }) => {
        if (viewmodel.get('realProductAttribute').getValue() == '2') {
          for (let i = 0, len = value.length; i < len; i++) {
            if (value[i].text == '线上批发') {
              cb.utils.alert('当选中虚拟商品时，线上批发不可选择', 'warning');
              return false
            }
          }
        }
      });
      // 销售渠道的值改变
      viewmodel.get('detail!saleChannel').on('afterValueChange', (args) => {
        diffsaleChannel(viewmodel, args);
      });
      // 销售方式
      viewmodel.get('saleStyle').on('afterValueChange', () => {
        diffsaleStyle(viewmodel);
      })
      const checkUnitName = (viewmodel, args, fieldname) => {
        let proxy = cb.rest.DynamicProxy.create({
          _label: { url: '/bill/check', method: 'POST' },
        });
        let datas = JSON.stringify(viewmodel.getAllData());
        let items = JSON.stringify({
          value: args.value,
          key: fieldname,
          location: '-1',
        });
        let params = { billnum: 'pc_product', data: datas, item: items };
        let returnPromise = new cb.promise();
        proxy._label(params, (err, args) => {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return returnPromise.reject();
          }
          if (args != undefined && args != '' && args != null) {
            if (args.error) {
              cb.utils.alert(args.error, 'error');
              return returnPromise.reject();
            }
          } else {
            return returnPromise.resolve();
          }
        })
        return returnPromise;
      }
      viewmodel.get('unit_Name').on('beforeValueChange', args => checkUnitName(viewmodel, args, 'unit_Name'))
      viewmodel.get('productTemplate_Name').on('beforeValueChange', args => checkUnitName(viewmodel, args, 'productTemplate_Name'))
      // 当 主计量单位 与 采购单位数 值一致时 采购单位换算率值为1
      viewmodel.get('unit_Name').on('afterValueChange', (args) => {
        // if (args.oldValue && args.value && args.value.id === args.oldValue.id) return false
        let mode = viewmodel.getParams().mode;
        let _mainval = _getValue(viewmodel, 'unit_Name');
        let _mainid = _getValue(viewmodel, 'unit');
        Object.keys(measurementUnitArr).forEach((v) => {
          if (v == 'detail!offlineUnit_Name' || v == 'detail!batchPriceUnit_Name') {
            viewmodel.get(v).setValue(_mainval);
            viewmodel.get(v.match(/(\S*)_Name/)[1]).setValue(_mainid);
            return false
          }
          let _val = _getValue(viewmodel, v);
          if (!_val) {
            viewmodel.get(v).setValue(_mainval);
            viewmodel.get(v.match(/(\S*)_Name/)[1]).setValue(_mainid);
          }
        })
        // diffbatchPriceUnit(viewmodel)
        diffmeasurementUnitArr(viewmodel);
      });
      // 批发单位
      // viewmodel.get("detail!batchUnit_Name").on('afterValueChange', (args) => {
      //   diffbatchPriceUnit(viewmodel)
      // })
      // 批发报价单位
      // viewmodel.get("detail!batchPriceUnit_Name").on("beforeBrowse", function(data) {
      //   var condition = { "isExtend": true, simpleVOs: [] };
      //   let unit = _getValue(viewmodel, 'unit');
      //   let batchUnit = viewmodel.get('detail!batchUnit').getValue()
      //   condition.simpleVOs = [{ field: 'id', op: 'in', value1: [unit, batchUnit] }];
      //   viewmodel.get("detail!batchPriceUnit_Name").setFilter(condition);
      // })
      // viewmodel.get("detail!batchPriceUnit_Name").on('beforeValueChange', (args) => {
      //   if (!args.value || !args.value.name) { return true }
      //   let unit = _getValue(viewmodel, 'unit');
      //   let batchUnit = _getValue(viewmodel, 'detail!batchUnit');
      //   if (args.value.id !== unit && args.value.id !== batchUnit) {
      //     cb.utils.alert('批发报价单位 只能从 主计量单位 和 批发单位 里选', 'warning');
      //     return false
      //   }
      // })
      Object.keys(measurementUnitArr).forEach((val) => {
        viewmodel.get(measurementUnitArr[val]).setState("min", 0);
        // viewmodel.get(measurementUnitArr[val]).setState("max", 99);
        viewmodel.get(val).on('afterValueChange', (args) => {
          diffUnit(viewmodel, val);
        })
      })
      // 管理分类
      viewmodel.get('manageClass_Name').on('afterValueChange', (args) => {
        let productClass_NameModel = viewmodel.get('productClass_Name');
        let productClass_Name = productClass_NameModel.getValue();
        let productClass = args.value && args.value.productClass; // 商品分类
        let productClassName = args.value && args.value.productClassName;
        if (!productClass_Name && productClassName) {
          productClass_NameModel.setValue(productClassName);
          viewmodel.get('productClass').setValue(productClass);
        }
        diffproductTemplate(viewmodel, args);
      })
      // 商品分类
      viewmodel.get('productClass_Name').on('afterValueChange', (args) => {
        let manageClass_NameModel = viewmodel.get('manageClass_Name');
        let manageClass_Name = manageClass_NameModel.getValue();
        let manageClass = args.value && args.value.manageClass; // 管理分类
        let manageClassName = args.value && args.value.manageClassName;
        if (!manageClass_Name && manageClassName) {
          manageClass_NameModel.setValue(manageClassName);
          viewmodel.get('manageClass').setValue(manageClass);
        }
        diffproductTemplate(viewmodel, args);
      })
      const diffproductTemplate_Name = (viewmodel) => {
        let productTemplate = _getValue(viewmodel, 'productTemplate'); // 商品分类ID
        clearTemplate(viewmodel); // 清空模板带来的数据
        if (!productTemplate) { // 为删除模板的时候
          SpecSums = []; // 商品规格
          specNamesObj = {}; // 商品规格名称 映射 {866937324097792: "free101", 857035213197568: "free100"}
          specIdsObj = {}; // 规格值 ID 与值的的映射
          SpecificationsShowItems = []; // SKU 列表里删除的SKU
          OrderPropertySums = []; // 订单属性
          enableCyclePurchase = false; // 是否启用周期购 默认false
          virtualProductAttributeData = 7; // 虚拟商品属性
          skusobj = {}; // 自定义规格对照 freex   {free101: "freex1"}
          skuobjIdName = []; // SKU自定义规格名称
          specItemObj = {}; // 规格项 ID -> Name 对比  {"free100":"规格名"}
          checkFreesData = []
          return false
        }
        templateLoad(productTemplate);
      }
      // 商品模板
      viewmodel.get('productTemplate_Name').on('afterValueChange', (args) => {
        diffproductTemplate_Name(viewmodel)
        firstInitSKU = 0
        templateLoadNumber = args.value ? 1 : 0 // 加载过物料模板
      })
      //  商品分类 选 末级 商品分类 管理分类 平台分类
      let classificationArr = [
        'productClass_Name',
        'manageClass_Name',
        "platformClass_Name",
      ]
      classificationArr.forEach((val) => {
        let valModel = viewmodel.get(val);
        valModel && valModel.on('beforeValueChange', ({ value }) => {
          if (value) {
            if (value.isEnd === false) {
              cb.utils.alert('请选择末级节点', 'warning');
              return false
            }
          }
        })
      })
      // 商品标签
      viewmodel.get('productTags').on('beforeValueChange', (args) => {
        if (!args) return true
        let tag_positionArr = args.value.map((val) => {
          if (val.scope.indexOf('前端展示') >= 0) {
            return val.tag_position && val.tag_position.value
          }
        })
        if (tag_positionArr.length) {
          let { max } = findMax(tag_positionArr);
          if (max > 1) {
            cb.utils.alert('前端展示的标签位置是唯一的', 'warning');
            return false
          }
        }
      })
      // 商品订单属性
      viewmodel.on('defaultskuorderpropery', () => {
        let defaultSKUOrderPropertiesModel = viewmodel.get('defaultSKUOrderProperties');
        let defaultSKUOrderPropertiesModelData = defaultSKUOrderPropertiesModel.getData();

        let skuOrderPropertiesModel = viewmodel.get('defaultSKUOrderProperties');
        let skuOrderPropertiesData = skuOrderPropertiesModel.getData();
        let _skuOrderPropertiesData = []; // 设置新的商品订单属性集合
        OrderPropertySums.length && OrderPropertySums.forEach((val, index) => {
          let _values = val.values;
          if (_values && _values.indexOf(';') >= 0) {
            _values = _values.replace(new RegExp('; ', 'g'), '|');
          }
          let __skuOrderPropertiesData = skuOrderPropertiesData.filter(v => v.skuPropertyTypeId == val.id); // 是否包含
          let _obj = {
            "skuPropertyTypeId_showItem": val.propertyType_showItem, // 属性名称
            "skuPropertyTypeId_alias": val.alias, // 属性别名
            "skuPropertyTypeId_type": val.propertyType_type, // 数据类型
            "skuPropertyTypeId_userdefMode": val.propertyType_userdefMode, // 录入方式
          };
          if (!__skuOrderPropertiesData.length) {
            _obj['skuPropertyTypeId'] = val.id;
            _obj['promptMessage'] = _values;
            _obj['isShow'] = val.isShow;
            _obj['isRequired'] = val.isRequired;
            _obj['iOrder'] = val.order;
            _obj['productApplyRangeId'] = val.productApplyRangeId;
            _obj['iLimitNum'] = val.propertyType_maxInputLen;
            skuOrderPropertiesModel.insertRow(index, _obj);
          } else {
            _obj['skuPropertyTypeId'] = __skuOrderPropertiesData[0].skuPropertyTypeId; // id
            _obj['promptMessage'] = __skuOrderPropertiesData[0].promptMessage; // 属性值
            _obj['isShow'] = __skuOrderPropertiesData[0].isShow; // 前端显示
            _obj['isRequired'] = __skuOrderPropertiesData[0].isRequired; // 前端必输
            _obj['iOrder'] = __skuOrderPropertiesData[0].iOrder; // 排序
            _obj['id'] = __skuOrderPropertiesData[0].id; // 排序
            _obj['productApplyRangeId'] = __skuOrderPropertiesData[0].productApplyRangeId; // 排序
            _obj['iLimitNum'] = __skuOrderPropertiesData[0].iLimitNum; // 字数限制
            skuOrderPropertiesModel.updateRow(index, _obj);
          }
          _skuOrderPropertiesData.push(_obj);
          skuOrderPropertiesModel.getEditRowModel().get('iLimitNum').setState('min', 0)
          skuOrderPropertiesModel.getEditRowModel().get('iLimitNum').setState('max', val.propertyType_maxInputLen)
        })
        skuOrderPropertiesData = skuOrderPropertiesModel.getData();
        let _delIndexs = [];
        skuOrderPropertiesData.map((v, index) => {
          if ((!OrderPropertySums[index] || v.skuPropertyTypeId !== OrderPropertySums[index].id) && v._status != "Delete") {
            _delIndexs.push(index);
          }
        })
        if (_delIndexs.length) {
          skuOrderPropertiesModel.deleteRows(_delIndexs);
        }
        // skuOrderPropertiesModel.setDataSource(_skuOrderPropertiesData)
        skuOrderPropertiesModel.on('beforeBrowse', function (data) {
          let datacontextModel = data.context;
          datacontextModel.setState('cSelfDefineType', OrderPropertySums[data.rowIndex]['propertyType_defineId']);
          datacontextModel.setState('bSelfDefine', true);
        })
        skuOrderPropertiesModel.on('rowColChange', ({ value }) => {
          switch (value.columnKey) {
            case "promptMessage":
              let rowData = skuOrderPropertiesModel.getRow(value.rowIndex);
              let skuPropertyTypeId_userdefMode = rowData.skuPropertyTypeId_userdefMode;
              let skuPropertyTypeId_type = rowData.skuPropertyTypeId_type;
              if (skuPropertyTypeId_userdefMode == 1 || skuPropertyTypeId_userdefMode == 2) { // 当本行的 录入方式 是 选择项或是 输入+选择 的时候 是Refer
                value.column.cControlType = 'Refer';
              } else {
                value.column.cControlType = 'Input';
              }
              if (skuPropertyTypeId_type === 'Double') {
                value.column.cControlType = 'InputNumber';
                let decimalDigits = OrderPropertySums[value.rowIndex].propertyType_decimalDigits || 0;
                value.column.iNumPoint = decimalDigits;
              }
              break;
            case "iLimitNum":
              value.column.max = OrderPropertySums[value.rowIndex].iLimitNum;
              break;
            default:
          }
        });
        viewmodel.communication({
          type: 'modal',
          payload: {
            mode: 'inner',
            groupCode: 'DefaultSKUOrderPropsDiv',
            viewModel: viewmodel,
          },
        })
      })

      /* ------------------------------------------------- SKU页签 ------------------------------------------------- */
      // sku列表批量上下架
      viewmodel.on('skumallshelve', () => {
        diffSKUShelve(viewmodel, "productSKUDetail!status", false)
      }); // 商城上架
      viewmodel.on('skumallunshelve', () => {
        diffSKUShelve(viewmodel, "productSKUDetail!status", true)
      }); // 商城下架
      viewmodel.on('skuuordershelve', () => {
        diffSKUShelve(viewmodel, "productSKUDetail!ustatus", false)
      }); // 订货上架
      viewmodel.on('skuuorderunshelve', () => {
        diffSKUShelve(viewmodel, "productSKUDetail!ustatus", true)
      }); // 订货下架
      // 展示 批量改行
      // viewmodel.on('SKUBatchEdit', (data) => {
      //   let params = data.params || '';
      //   if (params) {
      //     let productskusModel = viewmodel.get('productskus');
      //     delete params.visible
      //     Object.keys(params).forEach(val => {
      //       if (params[val] !== null) {
      //         productskusModel.setColumnValue(val, params[val]);
      //       }
      //     })
      //   };
      //   // diffcalTotalInventory(viewmodel);
      // })
      // 批改 某些字段非创建者不让修改
      viewmodel.on("batchModifySetFields", function (fieldsArr) {
        let _arr = ['code', 'name', 'modelDescription']
        createNumberList(60).forEach((v, index) => {
          _arr.push('skudefine!define' + (index + 1));
        });
        if (!diffcreator(viewmodel)) {
          fieldsArr.map((v) => {
            if (_arr.includes(v.fieldName)) {
              v.bCanFilter = false
              v.bCanModify = false
            }
            return v
          })
        } else {
          fieldsArr.map((v) => {
            if (v.fieldName === 'code') {
              v.bCanFilter = false
              v.bCanModify = false
            }
            return v
          })
        }
      })
      // 点击 会员价
      viewmodel.on('skulvprice', (args) => {
        diffskulvprice(viewmodel, args);
      });
      // 点击商品订单属性
      viewmodel.on('orderpropery', (args) => {
        diffOrderPropertySums(viewmodel, OrderPropertySums, args);
      })
      const createSKU = (args, ReDoSKU) => {
        let productskusList = productskusModel.getAllData();
        let newvalue = viewmodel.get('productspecitems').getShowValue() || [];
        let idObj = {}; // 规格值 Id集合
        specIdsObj = {}; // 规格值 ID 与值的的映射
        newvalue.forEach((v) => {
          if (idObj.hasOwnProperty(v.iSpecId)) {
            idObj[v.iSpecId].push(v.lsSpecItems_id);
          } else {
            idObj[v.iSpecId] = [v.lsSpecItems_id];
          }
          specIdsObj[v.lsSpecItems_id] = v.specValue
        })

        /** 判断当前已经选择的规格项 与 取模板时候的规格项 （数量、内容）映射 对比
         * 不等->清空列表
         * 等于->继续添加SKU 数据
         */
        let arr1 = Object.keys(idObj);
        let arr2 = Object.keys(specNamesObj);
        if (arr1.length !== arr2.length || arr1.sort().toString() !== arr2.sort().toString()) {
          if (productskusList.length) {
            productskusModel.deleteRows(createNumberList(productskusList.length));
          }
          return false
        }
        let _arr = [];
        if (Object.keys(specNamesObj).length) {
          _arr = Object.keys(specNamesObj).map((v) => {
            if (!v) return false
            return idObj[v].map((val) => {
              let SpecificationsArr_v = skusobj[specNamesObj[v]];
              return {
                [SpecificationsArr_v]: val,
              }
            })
          })
        }
        _arr = combine(_arr.reverse()); // 笛卡尔积
        let _delarr = [];
        let mixSKUIdArr = [];
        _arr.forEach((val) => {
          let specIds = Object.keys(specNamesObj).map((v) => {
            let SpecificationsArr_v = skusobj[specNamesObj[v]];
            return val[SpecificationsArr_v] + ''
          });
          // 排序 从小到大
          specIds.sort((a, b) => (a - b));
          specIds = specIds.join(';')
          mixSKUIdArr.push(specIds);
        })
        // 剔除 sku列表中未包含 现有规格值生产的笛卡尔积的值
        productskusList.forEach((val, index) => { // 排序 从小到大
          let _specIds = val.specIds.split(';');
          _specIds = _specIds.sort((a, b) => (a - b)).join(';');
          if (mixSKUIdArr.indexOf(_specIds) < 0) {
            _delarr.push(index)
          }
        })
        productskusModel.deleteRows(_delarr);
        // 增加 和 生成 sku列表 -> 在这更换 规格 name 和 装载 混合SKU name
        let ReDoSKURowDatas = []; // 重新生成sku列表里面的行数据 （弹窗的 数据）
        let _insertRowDatas = []; // 新生生成的 rowdata 集合
        let price = getPriceToSKU(viewmodel);
        let baseInfo = getbaseInfoToSKU(viewmodel); // 商品编码、商品名称、商品简称、规格型号
        _arr.forEach((val, index) => {
          let specs = '';
          let specIds = Object.keys(specNamesObj).map((v) => {
            let _specIds = val[skusobj[specNamesObj[v]]]
            specs += (specItemObj[specNamesObj[v]] + ':' + specIdsObj[_specIds] + ';')
            return _specIds
          }); // 前端根据 笛卡尔积生成的 唯一Id串
          // let specs = specIds.map(v => specIdsObj[v]); // 前端根据 笛卡尔积生成的 唯一name串
          let productsku = productskusList.filter(v => specIds.every(specId => v.specIds.includes(specId + '')));
          // v.specIds == specIds.join(';')
          if (productsku.length) {
            return /* return productsku[0] */
          } // sku 列表中已经有中断循环
          let _val = {}; // 在这更换 规格 name
          Object.keys(val).forEach((v) => {
            _val[v] = specIdsObj[val[v]]
          })
          let rowData = Object.assign(_val, staticSKU, { // 装载 混合SKU name
            specIds: specIds.join(';'),
            specs: specs,
            isShow: true,
            index: index,
          }, ...skuobjIdName, price, baseInfo);
          if (ReDoSKU == 'ReDoSKU') {
            ReDoSKURowDatas.push(rowData);
          } else {
            _insertRowDatas.push({ rowIndex: index, rowData: rowData });
          }
        })
        _insertRowDatas.length && productskusModel.batchInsertRow(_insertRowDatas);
        diffmergeCell(_arr, viewmodel)
        if (ReDoSKU == 'ReDoSKU') {
          if (ReDoSKURowDatas.length) {
            let _SpecificationsShowItems = [];
            JSON.parse(JSON.stringify(SpecificationsShowItems)).forEach((v) => {
              v.dataIndex = skusobj[v.dataIndex];
              _SpecificationsShowItems.push(v);
            })
            viewmodel.communication({
              type: 'modal',
              payload: {
                key: 'RcreateSKU',
                data: {
                  model: viewmodel,
                  data: ReDoSKURowDatas,
                  columns: _SpecificationsShowItems,
                },
              },
            });
          } else {
            cb.utils.alert('SKU值已全部生成', 'warning');
          }
        }
      }
      // 规格项值
      viewmodel.get('productspecitems').on('afterValueChange', (args) => {
        createSKU(args);
        diffcalTotalInventory(viewmodel);
      })
      // 重新生成的SKU
      viewmodel.on('afterHandleOK', function (args) {
        if (args.key !== 'RcreateSKU' || !args.value.length) return false
        let _value = args.value;
        _value.forEach((val) => {
          let _index = val.index;
          delete val.index
          productskusModel.insertRow(_index, val);
        })
        diffmergeCell(viewmodel, viewmodel);
      })
      let diffdeleteSKU = (args) => {
        let productskusModel = viewmodel.get("productskus");
        let mode = viewmodel.getParams().mode;
        if (mode === 'browse') {
          cb.utils.alert('浏览状态下不能删除规格', 'warning');
          return false
        }
        if (!diffcreator(viewmodel)) {
          cb.utils.alert('非创建者不能删除', 'warning');
          return false
        }
        let _indexs = [];
        if (args.cAction === "skubatchdelete") {
          _indexs = productskusModel.getSelectedRowIndexes();
          if (!_indexs.length) {
            cb.utils.alert("未选中sku列表", 'warning');
            return false
          }
        }
        if (args.cAction === "skudelete") _indexs = [args.params.index]
        if (mode === "edit") {
          let datas = [];
          if (args.cAction === "skubatchdelete") {
            let selectDatas = productskusModel.getSelectedRows()
            selectDatas.forEach((data) => {
              datas.push({
                "id": data.id,
                "isCreator": data["isCreator"],
                "biz": args.cParameter,
                "productApplyRangeId": data["productSKUDetail!productApplyRangeId"],
              });
            })
          } else if (args.cAction === "skudelete") {
            let data = productskusModel.getRow(args.params.index);
            datas.push({
              "id": data.id,
              "isCreator": data["isCreator"],
              "biz": args.cParameter,
              "productApplyRangeId": data["productSKUDetail!productApplyRangeId"],
            });
          }
          let proxy = cb.rest.DynamicProxy.create({
            ensure: { url: args.cSvcUrl, method: args.cHttpMethod },
          });
          let params = {
            billnum: "pc_product",
            action: args.cAction,
            data: JSON.stringify(datas),
          }
          proxy.ensure(params, function (err, result) {
            if (err) {
              cb.utils.alert(err.message, 'error');
              return;
            }
            let skuGridModelList = productskusModel.getAllData();
            // 查找不能删除的index
            let failDeleteName = "";
            let failDeleteIndexs = result.keys && result.keys.length ? skuGridModelList.map((modelData, index) => {
              if (result.keys.includes(modelData.id)) {
                failDeleteName += modelData.name
                return index
              }
            }) : [];
            if (result.sucessCount) {
              _.pullAll(_indexs, failDeleteIndexs);
              productskusModel.deleteRows(_indexs);
              deleteProductspecitems()
              diffcalTotalInventory(viewmodel);
              cb.utils.alert(args.cShowCaption + '成功' + result.sucessCount + '条', 'success');
            }
            if (result.failCount) {
              cb.utils.alert(failDeleteName + result.messages)
            }
          });
        } else if (mode === 'add') {
          productskusModel.deleteRows(_indexs);
          deleteProductspecitems()
          diffcalTotalInventory(viewmodel);
          cb.utils.alert("操作成功", 'success');
        }
      }
      // 删除规格值
      const deleteProductspecitems = () => {
        // 获取规格的值
        let productspecitemsModel = viewmodel.get('productspecitems');
        let SpecSums = productspecitemsModel.getShowValue(); // 规格
        let productskusList = viewmodel.get("productskus").getAllData();
        let AllspecIds = productskusList.map(v => v.specIds).join(';')
        let specSumsIndexs = []
        SpecSums.forEach((v, index) => {
          if (!AllspecIds.includes(v.lsSpecItems_id + "")) {
            specSumsIndexs.push(index)
          }
        })
        specSumsIndexs.length && productspecitemsModel.deleteItems(specSumsIndexs);
      // 删除
      }
      viewmodel.on('skudelete', (args) => {
        if (args.cItemName === "btnSKUDelete") {
          diffdeleteSKU(args);
        }
      })
      // 批量删除
      viewmodel.on('skubatchdelete', (args) => {
        diffdeleteSKU(args);
      })

      // 批量删除
      viewmodel.on('skubatchdelete', args => diffdeleteSKU(args))
      // 设置SKU表格按钮状态
      productskusModel.on('afterSetActionsState', (args) => {
        let isCreator = diffcreator(viewmodel);
        !isCreator && args.length && args.map((val) => {
          val.btnSKUDelete.visible = false
          return val
        })
      });
      // 重新生成 sku
      viewmodel.on('ReDoSKU', () => {
        diffcreator(viewmodel) && createSKU(true, 'ReDoSKU');
      })

      /* ------------------------------------------------ 业务信息 ------------------------------------------------ */
      // 启用周期购
      viewmodel.get('detail!iEnableCyclePurchase').on('beforeValueChange', (args) => {
        if (args.value.value === 'true' || args.value.value === true) {
          if (!enableCyclePurchase) {
            cb.utils.alert('请先为商品设置一个启用周期购的商品模板', 'warning');
            return false
          }
        }
      })
      viewmodel.get("detail!enableDeposit").on('afterValueChange', () => {
        diffenableDeposit(viewmodel);
      }) // 启用预定业务
      viewmodel.get("detail!depositDealPayType").on('afterValueChange', () => {
        diffdepositDealPayType(viewmodel);
      }) // 定金设置方式
      viewmodel.get("detail!depositPayType").on('afterValueChange', () => {
        diffdepositPayType(viewmodel);
      }) // 支付尾款方式
      viewmodel.get("time!iControlTime").on('afterValueChange', () => {
        difftimes_iControlTime(viewmodel);
      }) // 线上付尾款规则
      viewmodel.get("time!ControlTimeType").on('afterValueChange', () => {
        difftimes_ControlTimeType(viewmodel);
      }) // 线上付尾款控制方式
      // 线上不显示价格时，需要显示的提示信息 默认不显示
      viewmodel.get("detail!isDisplayPrice").on('afterValueChange', () => {
        diffisDisplayPrice(viewmodel);
      }) // 线上商城显示价格
      viewmodel.get("time!dateRange").on('afterValueChange', (args) => { // 尾款日期范围
        viewmodel.get('time!dStartDate').setValue(args.value[0])
        viewmodel.get('time!dEndDate').setValue(args.value[1])
      })
      viewmodel.get("detail!isBatchManage").on('afterValueChange', () => {
        diffisBatchManage(viewmodel);
      }) // 批次管理
      viewmodel.get('detail!isSerialNoManage').on('afterValueChange', () => {
        diffisSerialNoManage(viewmodel);
      }) // 序列号管理
      viewmodel.get("detail!isExpiryDateManage").on('afterValueChange', () => {
        diffisExpiryDateManage(viewmodel);
      }) // 有效期管理
      viewmodel.get('detail!isProcess').on('afterValueChange', (args) => {
        diffisProcess(viewmodel);
      }) // 加工
      viewmodel.get('detail!processType').on('afterValueChange', (args) => {
        diffprocessType(viewmodel);
      }) // 加工方式
      viewmodel.get('detail!canOrder').on('afterValueChange', (args) => {
        diffcanOrder(viewmodel)
      }) // 仅预约
      // 电商仓过滤
      let omsWarehouse_NameModel = viewmodel.get("detail!omsWarehouse_Name");
      omsWarehouse_NameModel.on('beforeBrowse', (agrs) => {
        let condition = { "isExtend": true, simpleVOs: [] };
        condition.simpleVOs = [{ field: 'eStore', op: 'in', value1: 1 }];
        omsWarehouse_NameModel.setFilter(condition);
      })

      /* ------------------------------------------------ 商品属性 ------------------------------------------------ */
      // 当选择 模板后  商品属性筛选
      const templateLoad = (id, edit) => {
        let proxy = cb.rest.DynamicProxy.create({
          _label: { url: '/api/product/tpl/data/' + id, method: 'GET' },
        });
        let params = { billnum: "pc_producttpl", id: id };
        proxy._label({}, (err, args) => {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return false;
          }
          let Parameters = args.Parameters || []; // 商品参数
          let PropertySums = args.PropertySums || []; // 商品扩展属性
          let Units = args.Units; // 计量单位
          let SKUPropertySums = args.SKUPropertySums || []; // SKU扩展属性
          let deliveryType = args.deliveryType || null; // 商城-运费模板Id
          let deliveryType_name = args.deliveryType_name || ''; // 商城-运费模板
          let FreightRule = args.FreightRule || null; // 订货-运费模板Id
          let FreightRule_name = args.FreightRule_name || ''; // 订货-运费模板
          let enableWeighing = args.enableWeighing || false; // 启用称重
          let productspecitemsModel = viewmodel.get('productspecitems'); // 规格
          let checkFreesModel = viewmodel.get('productCheckFrees'); // 指定核算的规格
          let isCheckFreeModel = viewmodel.get('detail!isCheckFree'); // 按规格核算
          SpecSums = args.SpecSums || []; // 商品规格
          SpecSums.sort((a, b) => (a.order - b.order))
          enableCyclePurchase = args.enableCyclePurchase || false; // 是否周期购
          OrderPropertySums = args.OrderPropertySums || []; // 订单属性
          // 当 商品参数 列表或是 商品扩展参数 列表不为空时 商品属性页签显示
          if (Parameters.length || PropertySums.length) {
            viewmodel.execute('updateViewMeta', {
              code: '商品属性页签',
              visible: true,
            });
          }
          viewmodel.execute('updateViewMeta', {
            code: 'DefaultSKUOrderPropsGroup',
            visible: (!SpecSums.length && !!OrderPropertySums.length),
          });
          diffPropertySums(viewmodel, PropertySums); // 显示、隐藏商品扩展属性
          // 只要有 规格列表 线上库存量不可填写并设置初始值 0
          // let lInventoryCountModel = viewmodel.get('detail!lInventoryCount');
          // lInventoryCountModel.setDisabled(!!SpecSums.length);
          // lInventoryCountModel.setValue(0);
          showItems2 = []; // 自定义规格
          let _frees = []; // cSelfDefineType 合集
          if (SpecSums.length) {
            let _SKUCondition = diffSKUCondition(viewmodel);
            viewmodel.execute('updateViewMeta', {
              code: 'SKU页签',
              visible: _SKUCondition,
            });
            if (_SKUCondition) {
              diffstopstatus(viewmodel);
            }
            let _SpecSums = [];
            checkFreesData = [];
            SpecSums.forEach((val) => {
              _SpecSums.push({
                value: val.specification,
                text: val.specification_showItem,
              })
              checkFreesData.push({
                freeId: val.specification,
                name: val.specification_showItem,
                disabled: !val.specification_isShowSpec,
              })
            })
            // 按照模板 规格排序
            productspecitemsModel.setState('keyField', 'iSpecId');
            productspecitemsModel.setState('dataSource', _SpecSums);
            // 按核算规格名称
            if (checkFreesData.length) {
              diffisCheckFree(viewmodel, checkFreesData);
              // 检测 specification_isShowSpec 为否的值是不是
              let _checkFreesData = checkFreesData.filter(v => !v.disabled);
              if (_checkFreesData.length) {
                isCheckFreeModel.setState('options', [
                  { value: "0", text: "不按规格核算", nameType: "text" },
                  { value: "1", text: "指定规格核算", nameType: "text" },
                  { value: "2", text: "按SKU核算", nameType: "text" },
                ])
              } else {
                isCheckFreeModel.setState('options', [
                  { value: "0", text: "不按规格核算", nameType: "text" },
                  {
                    value: "1",
                    text: "指定规格核算",
                    nameType: "text",
                    disabled: true,
                  },
                  { value: "2", text: "按SKU核算", nameType: "text" },
                ])
              }
              viewmodel.get('detail!isCheckFree').on('afterValueChange', (args) => { // 按规格核算
                diffisCheckFree(viewmodel, checkFreesData)
              })
            }
            isCheckFreeModel.setState('visible', _SKUCondition);
            checkFreesModel.setState('visible', _SKUCondition);
            // sku列表 规格 显示隐藏
            specNamesObj = {}; // 规格名称映射初始化
            let showItems = []; // 预制规格 只有10个 free1-free10 预制规格的 specification_isShowSpec = true
            skusobj = {}; // 规格->标记 映射
            let skucount = 1; // 自定义规格索引
            skuobjIdName = []; // 自定义规格名称 与ID集合
            specItemObj = {};
            let _params = viewmodel.getParams();
            let _productskusList = productskusModel.getAllData();
            let _firstProductskusList = _productskusList[0];
            SpecSums.forEach((v) => {
              showItems.push({
                "title": v.specification_showItem,
                "dataIndex": v.specification_defineId,
              });
              _frees.push(v.specification_defineId);
              if (!v.specification_isShowSpec) {
                if (_params.mode !== 'add' && _productskusList.length) {
                  skuobjIdName.push({
                    ['freeidx' + skucount]: _firstProductskusList['freeidx' + skucount],
                    ['freeidx' + skucount + '_Name']: _firstProductskusList['freeidx' + skucount + '_Name'],
                  });
                  // 由sku列表值 反选 规格项
                  skusobj[v.specification_defineId] = Object.keys(_firstProductskusList).filter(val => v.specification == _firstProductskusList[val])[0].replace('id', ''); // 反选id
                } else {
                  skusobj[v.specification_defineId] = 'freex' + skucount;
                  skuobjIdName.push({
                    ['freeidx' + skucount]: v.specification,
                    ['freeidx' + skucount + '_Name']: v.specification_showItem,
                  });
                }
                showItems2.push({
                  title: v.specification_showItem,
                  dataIndex: v.specification_defineId,
                });
                skucount++
              } else {
                skusobj[v.specification_defineId] = v.specification_defineId;
              }
              specItemObj[v.specification_defineId] = v.specification_showItem;
              specNamesObj[v.specification] = v.specification_defineId;
            })
            SpecificationsShowItems = showItems;
            createNumberList(10).forEach((val, i) => {
              let _free = 'free' + (i + 1);
              productskusModel.setColumnState(_free, 'visible', _frees.indexOf(_free) >= 0);
              productskusModel.setColumnState(_free, 'cShowCaption', specItemObj[_free]);
              if (_frees.indexOf(_free) >= 0) {
                productskusModel.setColumnState(_free, "bMergeCol", true);
              }
            })
            diffFreex(viewmodel, productskusModel, showItems2); // 自由项显示隐藏
          }
          diffSKUPropertySums(productskusModel, SKUPropertySums, viewmodel); // 隐藏SKU扩展属性

          let productparamsModel = viewmodel.get('productParams');
          let productparamsData = productparamsModel.getData() || [];
          if (edit) { // 编辑态
            if (productparamsData.length) {
              let delrow = [];
              productparamsData.forEach((val, index) => {
                let _productparamsData = Parameters.filter(v => val.param == v.id);
                if (!_productparamsData.length) {
                  delrow.push(index);
                }
              })
              productparamsModel.deleteRows(delrow);
            }
            Parameters.forEach((v, i) => {
              let _productparamsData = productparamsData.filter(val => val.param == v.id);
              if (_productparamsData.length) {
                let addRowData = {};
                addRowData = _productparamsData[0];
                addRowData.param_GroupName = v.group;
                addRowData.param_Name = v.name;
                if (!addRowData.paramValue) addRowData.paramValue = null
                productparamsModel.updateRow(i, addRowData);
              } else {
                productparamsModel.insertRow(i, {
                  param_GroupName: v.group,
                  param_Name: v.name,
                  param: v.id,
                });
              }
            })
          } else { // 新增状态 或是 修改模板的时候
            viewmodel.get("detail!iEnableCyclePurchase").setValue(enableCyclePurchase);
            viewmodel.get("detail!isWeight").setValue(enableWeighing);
            if (deliveryType) {
              viewmodel.get("detail!dlyFeeRuleId").setValue(deliveryType);
              viewmodel.get("detail!dlyFeeRuleId_Name").setValue(deliveryType_name);
            }
            if (FreightRule) {
              viewmodel.get("detail!uorderDlyFeeRuleId").setValue(FreightRule);
              viewmodel.get("detail!uorderDlyFeeRuleId_Name").setValue(FreightRule_name);
            }
            Parameters.forEach((v) => {
              productparamsModel.appendRow({
                param_GroupName: v.group,
                param_Name: v.name,
                param: v.id,
              });
            })
            hasUnits(Units) && updatemeasurementUnitArr(viewmodel, Units[0]); // 更新计量单位
          }
        })
      }

      /**
      productskusModel.on('beforeSetColumns', (columns) => {
        debugger
        // 固定自定义项
        createNumberList(10).forEach((val, i) => {
          let _free = 'free' + (i + 1);
          columns[_free].bShowIt = _frees.indexOf(_free) >= 0
        })
        // 自定义规格项
        diffFreex(viewmodel, productskusModel, showItems2);
        createNumberList(5).forEach((val, i) => {
          let _showit = !(i > showItems2.length - 1);
          columns['freex' + (i + 1)].bShowIt = _showit
        })
        diffSKUPropertySums(productskusModel, SKUPropertySums, viewmodel); // 隐藏SKU扩展属性
        return columns
      })
 */

      /* -------------------------------------------- 适用范围 -------------------------------------------- */
      viewmodel.on('beforeDeleteRow', (args) => {
        let childrenField = args.params.childrenField;
        let _data = viewmodel.get(childrenField).getRow(args.params.params.index);
        let isCreator = typeBool(_data.isCreator, false)
        if (childrenField == "productShops" && isCreator) { // 商家
          cb.utils.alert("创建者商家不允许删除", 'warning');
          return false;
        } else if (childrenField == "productOrgs") { // 组织
          let user_orgId = cb.rest.AppContext.user ? cb.rest.AppContext.user.orgId : null;
          if (isCreator) {
            cb.utils.alert("创建者组织不允许删除", 'warning');
            return false;
          } else if (user_orgId == _data.orgId) {
            cb.utils.alert("不能删除当前登录组织", 'warning');
            return false;
          }
        }

        //lichi 条码计量单位只有一行时 隐藏删行按钮
        if (args.params.cCommand == 'cmdDeleteRow_barcodeUnit') {
          let barCodeTable = viewmodel.get('productBarCodes').getAllData();
          if (barCodeTable.length === 2) {
            for (let i = 0; i < viewmodel.get('productBarCodes').getRows().length; i++) {
              viewmodel.get('productBarCodes').setActionState(i, "btnDeleteRow_barcodeUnit", "visible", false);
            }
          }
        }
      })
      // SKU 列表排序
      viewmodel.on('tabActiveKeyChange', function (params) {
        if (params.key === "SKU页签" && !firstInitSKU && SpecSums.length > 1) {
          setTimeout(function () {
            let productskusModel = viewmodel.get('productskus');
            firstInitSKU++
            // 基础规格排序
            let _firstName = [
              "free1",
              "free2",
              "free3",
              "free4",
              "free5",
              "free6",
              "free7",
              "free8",
              "free9",
              "free10",
            ];
            let _secondName = [
              "freex1",
              "freex2",
              "freex3",
              "freex4",
              "freex5",
            ][Symbol.iterator]();
            let _columns = productskusModel.getColumns();
            let fieldNames = [];
            for (let value of Object.values(_columns)) {
              if (!value.bHidden) fieldNames.push(value.fieldName)
            }
            let newFieldNameList = SpecSums.map((v) => {
              if (_firstName.includes(v.specification_defineId)) { // false  自定义数据
                return v.specification_defineId
              } else {
                return _secondName.next().value;
              }
            })
            // 判断是不是含有 预制规格
            let isInclude_firstName = newFieldNameList.filter(v => _firstName.includes(v));
            // if (!isInclude_firstName.length) return
            fieldNames = Array.from(new Set([
              ...newFieldNameList,
              ...fieldNames,
            ]))
            fieldNames.forEach((v, index) => {
              _columns[v].iOrder = index
            })
            let productskusList = productskusModel.getAllData();
            // 自由规格项 排序
            let rightList = []
            let _currentObj = {
              "freeidx1": "freex1",
              "freeidx2": "freex2",
              "freeidx3": "freex3",
              "freeidx4": "freex4",
              "freeidx5": "freex5",
            }
            if (showItems2.length > 1 && productskusList.length > 0) {
              let productspecitemsDataSource = viewmodel.get("productspecitems").getState('dataSource');
              let productskus0 = productskusList[0];
              productspecitemsDataSource.forEach((v) => {
                let __currentObj = Object.entries(productskus0).find(([key, value]) => value == v.value);
                if (__currentObj) {
                  rightList.push(_currentObj[__currentObj[0]])
                }
              })
              let _i = 0;
              newFieldNameList.forEach((v, index) => {
                if (rightList.includes(v)) {
                  newFieldNameList[index] = rightList[_i]
                  _i++
                }
              });
            }
            productskusModel.setColumns(_columns, Array.from(new Set([
              ...newFieldNameList,
              ...fieldNames,
            ])))
          }, 40)
        }
      })
      // 适用范围-商家列表过滤
      let productShopsModel = viewmodel.get("productShops");
      productShopsModel.on("beforeBrowse", function (data) {
        if (data) {
          switch (data.cellName) {
            case 'shopName':
              let rows = productShopsModel.getRows();
              let shopIds = [];
              rows.forEach((item, index) => {
                if (data.rowIndex === index) return;
                if (item.shopName === undefined) return;
                shopIds.push(item.shopId);
              })
              let condition = { "isExtend": true, simpleVOs: [] };
              condition.simpleVOs = [{
                field: 'id',
                op: 'nin',
                value1: shopIds,
              }];
              data.context.setFilter(condition);
              break;
            default:
          }
        }
      })

      // lichi 条码计量单位 打开参照前
      viewmodel.get('productBarCodes').setState('showRowNo', true);
      //lichi 条码计量单位 隐藏表格上3个点
      //viewmodel.get('productBarCodes').setState('showColumnSetting', false);
      viewmodel.get('productBarCodes').on('beforeBrowse', (args) => {
        var condition = {"isExtend": true, simpleVOs: []};
        condition.simpleVOs = [{
          field: 'id',
          op: 'in',
          value1: [],
        }];
        //主计量单位id
        if (viewmodel.get('unit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('unit').getValue());
        }
        //采购单位ID
        if (viewmodel.get('detail!purchaseUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!purchaseUnit').getValue());
        }
        //库存单位ID
        if (viewmodel.get('detail!stockUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!stockUnit').getValue());
        }
        //批发报价单位id
        if (viewmodel.get('detail!batchPriceUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!batchPriceUnit').getValue());
        }
        //线上零售单位id
        if (viewmodel.get('detail!onlineUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!onlineUnit').getValue());
        }
        //要货单位id
        if (viewmodel.get('detail!requireUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!requireUnit').getValue());
        }
        //线下零售单位id
        if (viewmodel.get('detail!offlineUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!offlineUnit').getValue());
        }
        //批发销售单位id
        if (viewmodel.get('detail!batchUnit').getValue() != null) {
          condition.simpleVOs[0].value1.push(viewmodel.get('detail!batchUnit').getValue());
        }
        //lichi 这是为了 计量单位参照只来自下面的业务单位
        if (condition.simpleVOs[0].value1.length == 0) {
          condition.simpleVOs[0].value1.push(-1);
          cb.utils.alert('请先设置主计量单位或者业务单位！', 'warning');
        }

        args.context.setFilter(condition);
      });
      viewmodel.get('productOrgs').on('beforeInsertRowFromRefer', args => diffOrgsScope(viewmodel, 'productOrgs', args.row.orgId))
      viewmodel.get('productOrgs').on('beforeCellValueChange', args => diffOrgsScope(viewmodel, 'productOrgs', args.value.id))
      let productLvPricesModel = viewmodel.get('productLvPrices');
      productLvPricesModel.on('beforeSetDataSource', (args) => {
        args.length && args.map((val) => {
          val.levelId_Discount += ' 折'
          return val
        })
        return true;
      })
      productLvPricesModel.setColumnState('fLevelPrice', 'min', 0);
      productLvPricesModel.setColumnState('levelId_Discount', 'disabled', true);
      //无分配组织权限时禁止修改适用范围
      if(cb.rest.AppContext.user.authCodes && cb.rest.AppContext.user.authCodes.length && !cb.rest.AppContext.user.authCodes.includes("pc_prosuitorg")) {
        let productOrgsModel = viewmodel.get("productOrgs");
        productOrgsModel.setColumnState("orgCode", "bCanModify", false);
      }

      /* -------------------------------------------- 页面数据加载之后 -------------------------------------------- */
      viewmodel.on('afterLoadData', (args) => {
        let enableDeposit = _getValue(viewmodel, 'detail!enableDeposit'); // 定金业务
        if (cb.utils.isEmpty(enableDeposit)) viewmodel.get('detail!enableDeposit').setValue(false)
        let enableSubscribe = _getValue(viewmodel, 'detail!enableSubscribe'); // 定金业务
        if (cb.utils.isEmpty(enableSubscribe)) viewmodel.get('detail!enableSubscribe').setValue(false)
        // 会员价 添加折
        let _params = viewmodel.getParams();
        let mode = _params.mode;
        let isAdd = (mode === 'add') // 是否是新增状态
        if (!isAdd) {
          viewmodel.get('dimensionCode').setValue(geturl(_params));
          // viewmodel.get('code').setDisabled(true);
        } else {
          viewmodel.get('productLvPrices').setState('readOnly', false)
        }
        viewmodel.get('detail!mallUpTime').setVisible(!isAdd) // 商城上架时间
        viewmodel.get('detail!uorderUpTime').setVisible(!isAdd) // U订货上架时间
        diffSource(viewmodel, _params.source); // 隐藏来源
        const userType = cb.rest.AppContext.user ? cb.rest.AppContext.user.userType : null;
        if (userType === 2 || userType === 3 || userType === 5 || userType === 4) {
          viewmodel.execute('updateViewMeta', {
            code: '适用范围页签',
            visible: false,
          });
        } else if (userType === 0 || userType === 1) {
          viewmodel.execute('updateViewMeta', {
            code: '适用范围页签',
            forceRender: true,
          });
          viewmodel.execute('updateViewMeta', {
            code: "OrgTabPage",
            visible: true,
          });
          viewmodel.execute('updateViewMeta', {
            code: "customerTabPage",
            visible: false,
          });
          viewmodel.execute('updateViewMeta', {
            code: "shopTabPage",
            visible: false,
          });
        }
        // if (userType === 5 || userType === 4) {
        //   viewmodel.get('detail!fSettleAccountsRate').setState('bIsNull', false); // 商家结算费率 必输
        // }
        // if (userType === 5 || userType === 4) {
        //   viewmodel.execute('updateViewMeta', { code: '适用范围页签', forceRender: true });
        //   viewmodel.execute('updateViewMeta', { code: "OrgTabPage", visible: false });
        //   viewmodel.execute('updateViewMeta', { code: "customerTabPage", visible: false });
        //   viewmodel.execute('updateViewMeta', { code: "shopTabPage", visible: true });
        // }
        //lichi 条码计量单位
        //强制渲染该页签 加载viewmodel 使隐藏按钮代码生效!
        viewmodel.execute('updateViewMeta', {
          code: '多条码页签',
          forceRender: true,
        });
        let barCodeTable = viewmodel.get("productBarCodes");
        // if (barCodeTable.getAllData().length === 0) {
        //   barCodeTable.appendRow({});
        //   barCodeTable.setActionState(0, "btnDeleteRow_barcodeUnit", "visible", false);
        // }
        // 判断 是否是 编辑态
        if (mode == 'browse' || (isAdd && !diffcreator(viewmodel))) {
          diffEdit(viewmodel, mode)
          viewmodel.get('btnSaveAndAdd').setVisible(false);

          // lichi
          viewmodel.get('btnAddRow_barcodeUnit').setVisible(false);
          for (let i = 0; i < viewmodel.get('productBarCodes').getRows().length; i++) {
            viewmodel.get('productBarCodes').setActionState(i, "btnDeleteRow_barcodeUnit", "visible", false);
          }
        }
        if (mode != 'browse') {
          //viewmodel.get('btnAddRow_barcodeUnit').setVisible(true);
        }
        // 将sku子表数据都传给后台，用于计算线上库存量
        // viewmodel.get('productskus').setDirty(true);
        saleChannel = _getValue(viewmodel, 'detail!saleChannel');
        virtualProductAttributeData = _getValue(viewmodel, 'virtualProductAttribute');
        diffrealProductAttribute(viewmodel, virtualProductAttributeData, saleChannel); // 商品性质
        loadfn(viewmodel);
        viewmodel.setCache("isLoaded", true);
      });
      viewmodel.on('afterEdit', (args) => {
        diffEdit(viewmodel)
      });
      // 浏览态和编辑态都需要
      const diffEdit = (viewmodel, mode) => {
        let _id = _getValue(viewmodel, 'productTemplate');
        if (!!_id) {
          templateLoad(_id, true); // 加载商品参数
        } else {
          viewmodel.execute('updateViewMeta', {
            code: '商品属性页签',
            visible: false,
          });
          viewmodel.execute('updateViewMeta', {
            code: 'SKU页签',
            visible: false,
          });
        }
        if (!mode || (mode && mode != 'browse')) {
          diffbasicInfo(viewmodel)
        }
        if (mode == 'browse') {
          viewmodel.get('productLvPrices').setState('readOnly', true)
        } else {
          viewmodel.get('productLvPrices').setState('readOnly', false)
        }
      }
      // 市场价默认取建议零售价
      viewmodel.on('beforeSave', (args) => {
        let isProductskuscode = diffproductskusCode(viewmodel);
        if (!isProductskuscode) {
          cb.utils.alert('SKU编码不能重复', 'error')
          return false
        }
        let mode = viewmodel.getParams().mode
        let data = JSON.parse(args.data.data);
        // if (mode === 'add' && defaultcode !== '') {
        //   data.ifEditAutoCode = data.code === defaultcode;//标记自动生成的商品编码是否手工修改过
        // }
        // 校验计量单位
        let rolesUnitRates = rolesUnits(viewmodel);
        if (rolesUnitRates.length) {
          cb.utils.alert(rolesUnitRates.join() + '不能为空', 'error');
          return false
        }
        let productskusData = data.productskus;
        // 商品订单属性 有值，孙表没值 则添加 值
        // 加载过模板 编辑物料模板则不赋值
        if (templateLoadNumber && productskusData && productskusData.length && OrderPropertySums.length) {
          // 获取默认订单属性
          let newSkuOrderProperties = [];
          OrderPropertySums.forEach((val, index) => {
            let _values = val.values;
            if (_values && _values.indexOf(';') >= 0) {
              _values = _values.replace(new RegExp('; ', 'g'), '|');
            }
            let _obj = {
              "skuPropertyTypeId_showItem": val.propertyType_showItem, // 属性名称
              "skuPropertyTypeId_alias": val.alias, // 属性别名
              "skuPropertyTypeId_type": val.propertyType_type, // 数据类型
              "skuPropertyTypeId_userdefMode": val.propertyType_userdefMode, // 录入方式
              "skuPropertyTypeId": val.id,
              "promptMessage": _values,
              "isShow": val.isShow,
              "isRequired": val.isRequired,
              "iOrder": val.order,
              "productApplyRangeId": val.productApplyRangeId,
              "iLimitNum": val.propertyType_maxInputLen,
            };
            newSkuOrderProperties.push(_obj);
          })
          data.productskus.map((v) => {
            if (!v["skuOrderProperties"] || !v["skuOrderProperties"].length) {
              v["skuOrderProperties"] = newSkuOrderProperties
            }
            return v
          })
        }
        if (productskusData && productskusData.length) {
          let _isSbatchUnit = false; // 商品和商品sku设置了批发销售单位，需校验换算率必填
          productskusData.forEach((v) => {
            if (v["productSKUDetail!batchUnit_Name"] && !v["productSKUDetail!batchRate"]) { // 批发销售单位 有值 批发销售单位换算率 没空
              _isSbatchUnit = true || _isSbatchUnit;
            }
          })
          if (_isSbatchUnit) {
            cb.utils.alert('SKU设置了批发销售单位,批发销售单位换算率不能为空!', "error")
            return false
          }
        }
        if (!_getValue(viewmodel, 'productTemplate_Name')) {
          data['detail!isCheckFree'] = '0'
        }
        let { productApplyRangeId, isCreator, isApplied } = cb.rest.AppContext.query;
        if (productApplyRangeId && isCreator && isApplied) { // U订货参数是从URL传过来的
          data.productApplyRangeId = productApplyRangeId
          data.isCreator = typeBool(isCreator)
          data.isApplied = typeBool(isApplied)
        } else if (carryParams) {
          productApplyRangeId = carryParams.productApplyRangeId;
          isCreator = carryParams.isCreator;
          isApplied = carryParams.isApplied;
          if (productApplyRangeId) data.productApplyRangeId = productApplyRangeId;
          if (typeof isCreator == 'boolean') data.isCreator = isCreator;
          if (typeof isApplied == 'boolean') data.isApplied = isApplied;
        }
        let productskus = data.productskus;
        if (productskus && productskus.length) {
          productskus = productskus.map((val) => {
            if (val.skuOrderProperties && val.skuOrderProperties.length) {
              val.skuOrderProperties = val.skuOrderProperties.map((v) => {
                if (!v.id) {
                  v._status = "Insert"
                }
                return v
              })
            }
            return val
          })
          data.productskus = productskus;
        }
        if (!diffcreator(viewmodel)) {
          data._status = 'Update';
          data['detail!_status'] = !data['detail!id'] ? 'Insert' : 'Update';
          data['time!_status'] = !data['time!id'] ? 'Insert' : 'Update';
          data['define!_status'] = !data['define!id'] ? 'Insert' : 'Update';
          data = insertState(data);
        } else {
          if (mode === 'add') {
            data['source'] = 0
            let priceArr = [
              'detail!fPrimeCosts', // 含税进货价
              'detail!batchPrice', // 批发价
              'detail!fMarkPrice', // 建议零售价
              'detail!fLowestMarkPrice', // 最低零售价
              'detail!fSalePrice', // 线上零售价
              'detail!fMarketPrice', // 市场价
              'detail!isDisplayPrice', // 线上显示价格
            ]
            let productPrice = [
              "productSKUDetail!fPrimeCosts", // 含税进货价
              "productSKUDetail!batchPrice", // 批发价
              "productSKUDetail!markPrice", // 建议零售价
              "productSKUDetail!fLowestMarkPrice", // 最低零售价
              "productSKUDetail!salePrice", // 线上零售价
            ]
            priceArr.forEach((v) => {
              if (data[v] === null) data[v] = 0
            })
            if (productskus && productskus.length) {
              productskus = productskus.map((val) => {
                productPrice.forEach((v) => {
                  if (val[v] === null) val[v] = 0
                })
                return val
              })
              data.productskus = productskus;
            }
          }
        }
        args.data.data = JSON.stringify(data);
      });
    },
  }
  try {
    module.exports = PC_pc_product_VM_Extend;
  } catch (error) {}
  return PC_pc_product_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_product_VM.Extend.js